import { render, staticRenderFns } from "./Chart2.vue?vue&type=template&id=edcd62a4&scoped=true&"
import script from "./Chart2.vue?vue&type=script&lang=js&"
export * from "./Chart2.vue?vue&type=script&lang=js&"
import style0 from "@@/core/components/dashboard/Chart2/Chart2Style.css?vue&type=style&index=0&id=edcd62a4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edcd62a4",
  null
  
)

export default component.exports